import { ColorPalette, ErrorState } from '@shared/components';

export default function UserNotActivePage() {
  return (
    <ErrorState
      title='ไม่สามารถเข้าใช้งานได้'
      description={`เนื่องจากบัญชีของคุณอยู่ในสถานะ "Inactive" กรุณาติดต่อผู้ดูแลระบบ\nเพื่อตรวจสอบสถานะการใช้งาน`}
      slotProps={{
        icon: {
          color: ColorPalette.PRIMARY,
        },
      }}
      fullscreen
    />
  );
}
